<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="profile-page">
    <edit-sidebar
      :isSidebarActive="editDataSidebar"
      :model="addModel"
      :info="userInfo"
      @closeSidebar="initEditSideBar"
    />
    <pass-sidebar
      :isSidebarActive="passDataSidebar"
      :model="true"
      @closeSidebar="initPassSideBar"
    />
    <!-- COL AREA -->
    <div class="vx-row">
      <!-- COL 1 -->
      <div class="vx-col w-full lg:w-2/4 md:w-1/3">
        <!-- ABOUT CARD -->
        <vx-card title="基本信息" class="mt-base">
          <div class="text-center" @click="activePrompt = true; isAvatarAcitve = -1">
            <vs-avatar
              style="box-shadow: 1px 1px 10px #888"
              size="100px"
              :src="require('@/assets/images/profile/default-avatar.png')"
              v-if="!userInfo.photoURL"
            />
            <vs-avatar
              style="box-shadow: 1px 1px 10px #888"
              size="100px"
              :src="userInfo.photoURL"
              v-else
            />
            <p class="text-xs" style="color:#ccc">(点击选择头像)</p>
          </div>

          <!-- USER BIO -->
          <div class="user-bio mt-2">
            <p class="text-center">{{ userInfo.motto || "一往无前！" }}</p>
          </div>

          <!-- OTEHR DATA -->
          <div class="mt-5">
            <h6>昵称:</h6>
            <p>{{ userInfo.displayName }}</p>
          </div>

          <div class="mt-5">
            <h6>用户名:</h6>
            <p>{{ userInfo.username }}</p>
          </div>

          <div class="mt-5">
            <h6>Email:</h6>
            <p>{{ userInfo.email || "无" }}</p>
          </div>

          <div class="mt-5">
            <h6>手机号:</h6>
            <p>{{ userInfo.phone || "无" }}</p>
          </div>

          <div class="mt-5">
            <h6>注册时间:</h6>
            <p>{{ userInfo.registerTime }}</p>
          </div>

          <div class="social-links lg:flex mt-4">
            <vs-button
              class="mr-4 w-full lg:w-1/2 mb-2"
              type="border"
              size="small"
              icon-pack="feather"
              icon="icon-edit"
              @click="editDataSidebar = true"
              >编辑</vs-button
            >
            <vs-button
              class="w-full lg:w-1/2 mb-2"
              type="border"
              size="small"
              color="warning"
              icon-pack="feather"
              icon="icon-edit-2"
              @click="passDataSidebar = true"
              >修改密码</vs-button
            >
          </div>
        </vx-card>
      </div>
      <!-- COL 3 -->
      <div class="vx-col w-full lg:w-1/4 md:w-1/3">
        <vx-card title="最近操作" class="mt-base">
          <ul v-if="behaviorDynamic.length > 0">
            <li
              :class="{ 'mt-8': index }"
              v-for="(item, index) in behaviorDynamic"
              :key="item.id"
            >
              <div class="flex items-center">
                <div class="leading-tight">
                  <p class="feed-author font-semibold">
                    {{ item.title }}
                  </p>
                </div>
              </div>
              <p class="mt-4">{{ item.content }}</p>
              <small class="mt-3 inline-block">{{
                item.create_time
              }}</small>
              <vs-divider/>
            </li>
          </ul>
          <p v-else>没有任何操作动态</p>
        </vx-card>
      </div>
    </div>

    <vs-prompt
      vs-title="选择头像"
      vs-accept-text="确定"
      vs-cancel-text="取消"
      @vs-accept="updateAvatar"
      @vs-cancel="closeAvatarList"
      :vs-active.sync="activePrompt"
    >
      <div class="vx-row pt-2 px-4">
          <div class="vx-col w-1/2 sm:w-1/2 md:w-1/4 xl:1/4" v-for="(img, index) in userAvatars" :key="index"  @click="setActiveImg(index)">
              <img :src="img" alt="latest-upload" class="mb-4 user-latest-image responsive" :class="{active: index==isAvatarAcitve}">
          </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import EditSidebar from "@/views/user/components/EditSidebar";
import PassSidebar from "@/views/user/components/PassSidebar";
import { updateProfile } from '@/api/user';
import { getDynamic } from '@/api/message';
import config from '@/config';

export default {
  data() {
    return {
      userInfo: {},
      editDataSidebar: false,
      passDataSidebar: false,
      addModel: false,
      activePrompt: false,
      isAvatarAcitve: -1,
      newAvatar: '',
      userAvatars: [
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-1.png', 
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-2.png',
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-3.png', 
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-4.png',
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-5.png', 
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-6.png',
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-7.png', 
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-8.png',
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-9.png', 
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-10.png',
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-11.png', 
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-12.png',
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-13.png', 
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-14.png',
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-15.png', 
        'http://matches-haai.oss-cn-shenzhen.aliyuncs.com/avatar/avatar-16.png',



      ],
      matchDynamic: [],
      behaviorDynamic: [],

    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.getDynamicList1()
    this.getDynamicList2()
  },
  computed: {},
  methods: {
    initEditSideBar() {
      this.editDataSidebar = false
      this.addModel = true
    },
    initPassSideBar() {
      this.passDataSidebar = false
    },
    setActiveImg(index) {
      this.isAvatarAcitve = index
      this.newAvatar = this.userAvatars[index]
    },
    updateAvatar() {
        let that = this
        updateProfile({
          nickname: that.userInfo.displayName,
          phone: that.userInfo.phone,
          avatar: that.newAvatar,
          motto: that.userInfo.motto
        }).then(res => {
          if (res.code == 1) {
            that.userInfo.photoURL = that.newAvatar
            localStorage.setItem('userInfo', JSON.stringify(that.userInfo))
            that.$vs.notify({
              color:'success', 
              text: '更新成功！',
              title: '提示',
              iconPack: 'feather',
              icon: 'icon-alert-circle'  
            })
          }
        })
      
    },
    closeAvatarList() {
      this.newAvatar = ''
    },
    getDynamicList1() {
      let that = this
      getDynamic({
        type: 1,
        page_index: 1,
        page_num: 10,
      }).then(res => {
        if (res.code === 1) {
          that.matchDynamic = res.data.list
        }
      })
    },
    getDynamicList2() {
      let that = this
      getDynamic({
        type: 2,
        page_index: 1,
        page_num: 8,
      }).then(res => {
        if (res.code === 1) {
          that.behaviorDynamic = res.data.list
        }
      })
    },
    
    
  },
  components: {
    EditSidebar,
    PassSidebar,
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/pages/profile.scss";

.user-latest-image.active {
  box-shadow: 1px 1px 24px #558bf7;
}
.user-latest-image {
  cursor: pointer;
  transition: .5s;
  border-radius: 50%;
}
.user-latest-image:hover {
  box-shadow: 1px 1px 24px #558bf7;
}
</style>
